export * from "./Rating";
export { default } from "./Rating";